function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.58964 10.4103L11.6281 6.3718M15.7593 3.9072L12.3504 14.986C12.0448 15.9792 11.8921 16.4758 11.6285 16.6404C11.4 16.7832 11.1167 16.8067 10.8678 16.7034C10.5808 16.5843 10.3482 16.1196 9.88345 15.1902L7.72432 10.8719C7.65058 10.7244 7.61367 10.6507 7.56441 10.5868C7.5207 10.5301 7.47007 10.4792 7.41336 10.4355C7.34946 10.3862 7.27552 10.3494 7.12803 10.2756L2.80977 8.11649C1.88035 7.65178 1.4156 7.41952 1.29651 7.1325C1.19323 6.88359 1.21678 6.60002 1.35958 6.37147C1.52423 6.10794 2.02086 5.9552 3.01404 5.64961L14.0929 2.24074C14.8737 2.00049 15.2639 1.88035 15.5277 1.97717C15.7574 2.06151 15.9386 2.24255 16.0229 2.47227C16.1198 2.736 15.9995 3.12641 15.7593 3.9072Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgComunication = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgComunication, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/comunication.dbb28a70.svg";
export { ForwardRef as ReactComponent };